import styled from "styled-components";
import { Text } from "../../components/UI/generalLayout/Layout.styled";
import Colors from "../../constants/Colors";

export const SchedulingContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 3fr 1fr;

  @media screen and (max-width: 760px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
  }
`;

export const SchedulingMedicsContainer = styled.div``;

export const SchedulingFilterContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const MedicScheduleContainer = styled.div`
  display: flex;

  @media screen and (max-width: 760px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  gap: 10px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const MedicScheduleImage = styled.img`
  width: 90px;
  height: 90px;

  border-radius: 50%;
`;

export const MedicScheduleContent = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  gap: 20px;
`;

export const CardScheduling = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px;

  /* gray/50 */

  background: #f9fafb;
  /* gray/200 */

  border: 1px solid #e5e7eb;
  border-radius: 8px;
`;

export const GoBackLinkContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const ScheduleDayCard = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    display: flex;

    gap: 10px;
  }
  justify-content: center;
  border-radius: 4px;
  text-align: center;
  background: ${Colors.SPM50};
  color: ${Colors.SPM500};

  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  max-height: 30px;
  border: none;
`;

export const SchedulingDetailText = styled(Text)`
  font-size: 16px;
`
